Ply.AllocationSelectButton = function(el, options) {
    this.dom = {
        el: el
    };
    this.options = options;

    this.originalLabel = this.dom.el.innerHTML.trim();

    this.render = this.render.bind(this);

    this.dom.el.addEventListener('click', this.options.onClick);
};

Ply.AllocationSelectButton.prototype.render = function() {
    //TODO: Uncomment the below line if you want to have some deeper logic on initial page load
    //this.dom.el.disabled = (this.dom.el.dataset.isAvailable === "false");
    this.dom.el.style.visibility = "visible";
    this.dom.el.innerHTML = (this.isSelected() ? this.originalLabel : this.originalLabel);
};

Ply.AllocationSelectButton.prototype.isSelected = function() {
    return this.dom.el.dataset.allocationSelect === this.options.props.selectedProductHandle;
};
